import { Post } from "../utils/ApiUtilities";

export  const AuthService = () => {
    const apiController = 'auth';

    const RegisterUser = async (formData, customHeaders = {}) => {
        try {
            const response = await Post(`${apiController}`+'/Registration', formData, customHeaders);
            return response;  // return response.data instead of full response
            
        } catch (error) {
            console.error('registration failed:', error);
            throw error;
        }
    };

    


    const LoginUser = async (formData, customHeaders = {}) => {
        try {
            const response = await Post(`${apiController}`+'/login', formData, customHeaders);
            return response;  // return response.data instead of full response
            
        } catch (error) {
            console.error('login failed:', error);
            throw error;
        }
    };
    
    return { RegisterUser ,LoginUser };
    

};

